"use client";
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { FaCirclePlay } from "react-icons/fa6";
import { Empty, Modal } from "antd";
import HomePageService from "@/services/api/HomeService";
import CommonImage from "@/components/common/image/CommonImage";
import "swiper/css";
import { getYoutubeEmbedUrl, getYoutubeThumbnailUrl } from "@/utils/youtube";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import Image from "next/image";
import SkeletonStudentReviewSection from "@/components/common/skeletons/SkeletonStudentReviewSection";

export default function StudentReviewSection({reviews=[]}) {
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideoLink, setcurrentVideoLink] = useState(null);

  const openModal = (video) => {
    console.log("video", video);
    setcurrentVideoLink(video.video_link);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setcurrentVideoLink(null);
  };

  return (
    <>
      {/* {loading ? (
        <SkeletonStudentReviewSection />
      ) : ( */}
        <section className="student-review_section section_padding">
          <div className="container">
            <div className="student-review-title bg-[linear-gradient(90deg,rgba(3,53,62,0.05)_0%,rgba(3,53,62,0.02)_100%)]">
              <CommonImage
                src={"/images/home-page/review.avif"}
                className="icon"
                alt="Icon"
              />
              <h2 className="main-title">আমাদের সেরা ছাত্রদের রিভিউ</h2>
            </div>

            {reviews?.length > 0 ? (
              <div className="student-review-slider">
                <div className="student-review">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    slidesPerView={1}
                    spaceBetween={20}
                    autoplay={false}
                    speed={1500}
                    loop={true}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    className="overflow-hidden"
                  >
                    {reviews.map((student, idx) => (
                      <SwiperSlide key={idx}>
                        <div className="student-review-card">
                          <div className="student-image-wrap">
                            <div className="student-review-img">
                              <Image
                                // src={
                                //   getYoutubeThumbnailUrl(student?.video_link) ??
                                //   "/images/home-page/student-profile.avif"
                                // }
                                src={
                                  student?.thumbnail_url ??
                                  "/images/home-page/student-profile.avif"
                                }
                                alt={student.name || "Student Image"}
                                className="student-img"
                                width={250}
                                height={250}
                              />
                              <div className="student-image-playbtn">
                                <button
                                  onClick={() => openModal(student)}
                                  className="play-btn"
                                  aria-label={`Play video of ${student.name}`}
                                >
                                  <FaCirclePlay className="play-icon" />
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="video-content">
                            <div className="top">
                              <h3 className="name">{student.name}</h3>
                              <p className="class-name">
                                {student?.designation}
                              </p>
                            </div>

                            <div className="bottom">
                              <p className="short-des">
                                {student?.sort_details}
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="student-arrow">
                  <div className="swiper-button-prev swiper-button-lock">
                    <button className="arrow-icon">
                      <CommonImage
                        src="/images/home-page/arrow-left.svg"
                        className="img-icon"
                        alt="Arrow Icon"
                      />
                    </button>
                  </div>
                  <div className="swiper-button-next swiper-button-lock">
                    <button className="arrow-icon">
                      <CommonImage
                        src="/images/home-page/arrow-right.svg"
                        className="img-icon"
                        alt="Arrow Icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Empty description="No review available" />
            )}
          </div>

          <Modal
            open={modalOpen}
            onCancel={closeModal}
            footer={null}
            width={800}
            className="video-modal"
            centered
            destroyOnHidden
          >
            <div className="video-wrapper aspect-w-16 aspect-h-9">
              <YoutubePlayer url={currentVideoLink} />
            </div>
          </Modal>
        </section>
      {/* )} */}
    </>
  );
}
